"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.HomeBreadcrumb = void 0;
var _hooks = require("../../hooks");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const HomeBreadcrumb = ()=>{
    const { translations } = (0, _hooks.useTranslations)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.HomeBreadcrumbRoot, {
        href: window.location.origin,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Name, {
            children: translations.home
        })
    });
};
exports.HomeBreadcrumb = HomeBreadcrumb;
